import { AddServiceAddressComponent } from './provider-availability/addserviceaddress/add-service-address.component';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { NgOtpInputModule } from 'ng-otp-input';
import { CalendarModule } from 'angular-calendar';
import { DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { IamportalComponent } from './iamportal/iamportal.component';
import { AddUserComponent } from './iamportal/adduser/add-user.component';
import { EditUserComponent } from './iamportal/edituser/edit-user.component';
import { UserService } from '../app/service/user.service';
import { MatNativeDateModule } from '@angular/material/core';
import { NotificationService } from './service/notification.service';
import { DatePipe } from '@angular/common';
import { AssignSchedulerComponent } from './assignment-arena/assign-scheduler/assign-scheduler.component';
import { AssignNursePractitionerComponent } from './assignment-arena/assign-nurse-practitioner/assign-nurse-practitioner.component';
import { AssignModalComponent } from './assignment-arena/assign-scheduler/assign-modal/assign-modal.component';
import { AssigntargetModalComponent } from './assignment-arena/assign-scheduler/assigntarget-modal/assigntarget-modal.component';
import { AssignnpModalComponent } from './assignment-arena/assign-nurse-practitioner/assignnp-modal/assignnp-modal.component';
import { AssignmentArenaComponent } from './assignment-arena/assignment-arena.component';
import { ManagementConfigurationComponent } from './management-configuration/management-configuration.component';
import { AssignCoderComponent } from './assignment-arena/assign-coder/assign-coder.component';
import { ManageCoderComponent } from './assignment-arena/assign-coder/manage-coder/manage-coder.component';
import { ClientManagementComponent } from './management-configuration/client-management/client-management.component';
import { ProjectManagementComponent } from './management-configuration/project-management/project-management.component';
import { AddClientComponent } from './management-configuration/client-management/add-client/add-client.component';
import { EditClientComponent } from './management-configuration/client-management/edit-client/edit-client.component';
import { AddProjectComponent } from './management-configuration/project-management/add-project/add-project.component';
import { EditProjectComponent } from './management-configuration/project-management/edit-project/edit-project.component';
import { ProviderAvailabilityComponent } from './provider-availability/provider-availability.component';
import { AvailabilityComponent } from './provider-availability/form/availability.component';
import { SlotCalendarComponent } from './provider-availability/slot-calendar/slot-calendar.component';
import { AvailabilityService } from './service/availability.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DisableButtonOnSubmitDirective } from './throttle.time';
import { TestsComponent } from './management-configuration/tests/tests.component';
import { InputComponent } from './input/input.component';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { AuthInterceptor } from './common/auth/auth.interceptor';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    IamportalComponent,
    AddUserComponent,
    EditUserComponent,
    AssignSchedulerComponent,
    AssignNursePractitionerComponent,
    AssignModalComponent,
    AssigntargetModalComponent,
    AssignnpModalComponent,
    AssignmentArenaComponent,
    ManagementConfigurationComponent,
    AssignCoderComponent,
    ManageCoderComponent,
    ClientManagementComponent,
    ProjectManagementComponent,
    AddClientComponent,
    TestsComponent,
    EditClientComponent,
    AddProjectComponent,
    EditProjectComponent,
    ProviderAvailabilityComponent,
    AvailabilityComponent,
    AddServiceAddressComponent,
    SlotCalendarComponent,
    DisableButtonOnSubmitDirective,
    InputComponent,
    PageNotFoundComponent,
  ],
  imports: [
    BrowserModule,
    NgOtpInputModule,
    MatMenuModule,
    MatTabsModule,
    AppRoutingModule,
    MDBBootstrapModule.forRoot(),
    NgxWebstorageModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    BrowserAnimationsModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatRadioModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    MatSelectModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    NgIdleKeepaliveModule.forRoot(),
    ModalModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    UserService,
    NotificationService,
    DatePipe,
    AvailabilityService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  entryComponents: [AddServiceAddressComponent],
})
export class AppModule {}
